const ORDER_TYPES = {
    GET_IT_SHIPPED: 'get it shipped'
};

export default {
    ORDER_TYPES
};
